import { cn } from "../../../lib/utils";

type ButtonTone = "primary" | "tonal" | "neutral" | "danger";

const BUTTON_BASE =
  "inline-flex h-8 shrink-0 items-center justify-center gap-1.5 whitespace-nowrap rounded-lg px-3 text-sm font-medium transition-[filter,background-color,color] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-card disabled:pointer-events-none disabled:opacity-50 [&_svg]:h-[15px] [&_svg]:w-[15px] [&_svg]:shrink-0";

const BUTTON_TONE: Record<ButtonTone, string> = {
  primary:
    "bg-primary text-primary-foreground shadow-[inset_0_1px_0_hsl(0_0%_100%/0.14),0_1px_2px_hsl(var(--primary)/0.35)] hover:brightness-[1.07] disabled:bg-foreground/[0.08] disabled:text-muted-foreground disabled:opacity-100 disabled:shadow-none",
  tonal:
    "bg-primary/10 text-primary shadow-[inset_0_0_0_1px_hsl(var(--primary)/0.12)] hover:bg-primary/[0.16]",
  neutral: "bg-foreground/[0.06] text-foreground hover:bg-foreground/10",
  danger:
    "bg-red-500/[0.08] text-red-700 hover:bg-red-500/[0.14] dark:text-red-400",
};

export const integrationButton = (tone: ButtonTone) =>
  cn(BUTTON_BASE, BUTTON_TONE[tone]);
